import React from 'react';

export const ArrowFull = ({ direction, color, width, height }) => {
  let dir = '180deg';
  switch (direction) {
    case 'right':
      dir = '0deg';
      break;
    case 'top':
      dir = '-90deg';
      break;
    case 'bottom':
      dir = '90deg';
      break;
    default:
      break;
  }
  return (
    <svg
      width={width ?? '21'}
      height={height ?? '20'}
      style={{ rotate: dir }}
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.83331 10H17.1666"
        stroke={color ?? 'black'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.3333 4.16663L17.1666 9.99996L11.3333 15.8333"
        stroke={color ?? 'black'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
